export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "build/scripts/client-0a8367f5100fc134a2a6.worker.js");
}
